// extracted by css-extract-rspack-plugin
export default {"box":"box___ofMDH","left":"left___hqK9n","radio":"radio___c0hft","right":"right___sP2A3","right_table":"right_table___SljTl"};